<template>
  <q-dialog
    :visible="isVisible"
    :title="`近${recordData.size || 0}个月销售等级`"
    width="350px"
    :innerScroll="false"
    :showFooter="false"
    @close="onClose"
  >
    <div style="height: 50px; line-height: 50px">
      型号：{{ recordData['list'] ? recordData['list'][0].bigModel : '' }}
    </div>
    <el-table
      :data="recordData['list']"
      v-loading="loading"
      border
      :height="300"
      element-loading-text="数据加载中"
      element-loading-spinner="el-icon-loading"
      :header-cell-style="{
        backgroundColor: '#FAFAFA',
        textAlign: 'center',
      }"
      :cell-style="{ textAlign: 'center' }"
      style="width: 100%"
    >
      <el-table-column
        prop="month"
        label="月份"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
        prop="salesPositioning"
        label="销售等级"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{ scope.row.salesPositioning }}
          <span
            class="iconfont"
            style="color: red; font-size: 14px"
            v-if="scope.row.saleLocationFlag == 'down'"
          >&#xe619;</span>
          <span
            class="iconfont"
            style="color: #0bb78e; font-size: 14px"
            v-else-if="scope.row.saleLocationFlag == 'up'"
          >&#xe600;</span>
          <span class="iconfont" style="font-size: 14px" v-else
          >&#xe659;</span>
        </template>
      </el-table-column>
    </el-table>
  </q-dialog>
</template>

<script>
export default {
  name: 'SalesPositioningDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object,
      default: () => ({})
    },
    searchForm: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    isVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  data() {
    return {
      loading: false,
      recordData: []
    }
  },
  watch: {
    visible(val) {
      if (val && this.row) {
        this.fetchData()
      }
    }
  },
  methods: {
    onClose() {
      this.isVisible = false
    },
    fetchData() {
      let data = {
        category: this.row.categoryName,
        bigModel: this.row.bigModel,
        payDateStart: this.searchForm.payDateStart,
        payDateEnd: this.searchForm.payDateEnd,
      }
      this.loading = true
      this.$q.productModelDetails
        .bigModelSalesPositioning({ data: data })
        .then((res) => {
          if (res.code === '200') {
            this.recordData = res.data
          } else {
            this.$message.error(res.message)
          }
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="stylus" scoped>
</style>
